import { createSelector } from '@reduxjs/toolkit';

import { selectErpEnabled } from '@store/slices/settingsSlice.tsx';
import {
  CATALOGUE_EDIT_LAYOUT_PERMISSION,
  selectIsStaff,
  selectUserPermissions,
  selectUserRoles,
} from '@store/slices/userSlice.tsx';
import { useAppSelector } from '@store/store.tsx';

const selectIsSuperuser = createSelector(selectUserRoles, (roles) =>
  roles.some((role) => role?.trim().toLowerCase() === 'superuser'),
);

export const selectHasCataloguePermission = createSelector(selectUserPermissions, (permissions) =>
  permissions.includes(CATALOGUE_EDIT_LAYOUT_PERMISSION),
);

export const selectCanEditCatalogue = createSelector(
  [selectErpEnabled, selectIsStaff, selectHasCataloguePermission, selectIsSuperuser],
  (erpEnabled, isStaff, hasPermission, isSuperuser) =>
    Boolean(isSuperuser || (isStaff && (!erpEnabled || hasPermission))),
);

export const useCanEditCatalogue = (): boolean => useAppSelector(selectCanEditCatalogue);
